(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ds-product-labels"] && !Shopify.designMode) return;
  try {
    (() => {
    const managedLabel = /קוד\s*קופון|הנחה|outlet|sold\s*out|אזל\s*המלאי|דגם\s*חדש|עיצוב\s*חדש|^new$/i;
    function suppressDuplicates(root) {
      const elements = root.querySelectorAll?.('.samita_productLabel-content') || [];
      elements.forEach((element) => {
        const owner = element.closest('product-card, product-gallery, .horizontal-product-card, .product-info');
        if (!owner) return;
        const labelRoot = owner.querySelector('[data-ds-labels]');
        const isProductInfo = owner.matches('.product-info[data-ds-labels-managed]');
        const isProductGallery = owner.matches('product-gallery') && owner.querySelector('.ds-label-surface');
        if (!labelRoot && !isProductInfo && !isProductGallery) return;
        const text = (element.textContent + ' ' + Array.from(element.querySelectorAll('img')).map(img => img.alt).join(' ')).trim();
        const hide = isProductInfo || isProductGallery || managedLabel.test(text) || labelRoot?.dataset.labelState === 'sold_out';
        if (hide) element.setAttribute('data-ds-label-suppressed', '');
        else element.removeAttribute('data-ds-label-suppressed');
      });
    }
    let queued = false;
    const schedule = () => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => { queued = false; suppressDuplicates(document); });
    };
    schedule();
    new MutationObserver((records) => {
      if (records.some(record => record.type === 'characterData' || record.addedNodes.length || record.removedNodes.length)) schedule();
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
    document.addEventListener('product:rerender', (event) => {
      const form = event.target;
      const fragment = event.detail?.htmlFragment;
      if (!form?.id || !fragment?.querySelectorAll) return;
      const replacements = fragment.querySelectorAll('[data-ds-labels][data-label-context="product"]');
      document.querySelectorAll('product-gallery[form]').forEach(gallery => {
        if (gallery.getAttribute('form') !== form.id) return;
        gallery.querySelectorAll('[data-ds-labels]').forEach(current => {
          const replacement = Array.from(replacements).find(item => item.dataset.dsLabels === current.dataset.dsLabels);
          if (replacement) current.replaceWith(replacement.cloneNode(true));
        });
      });
      schedule();
    }, true);
  })();
  } catch(e) { console.error(e); }
})();

})();
